<template>
  <div class="modal-content">
    <form novalidate @submit.prevent="save">
      <ErrorMessage v-if="errorText" :error-message="errorText"></ErrorMessage>

      <label class="form-control-label">Дата начала периода</label>
      <input
          v-model="start"
          type="date"
          class="form-control form-control-light"
          :min="minDate"
      />

      <label class="form-control-label">Дата конца периода</label>
      <input
          v-model="end"
          type="date"
          class="form-control form-control-light"
          :min="start || minDate"
          :max="maxEndDate"
      />

      <div class="form-footer">
        <button class="btn btn-middle" type="submit" :disabled="!isValid">
          Скачать отчет
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import ErrorMessage from "@/components/common/ErrorMessage";
import { getLastPeriodDate, isPeriodInMonthsValid } from "@/utils/datetime";

export default {
  name: "DateRangeModal",
  components: {
    ErrorMessage,
  },
  props: {
    componentProps: {
      type: Object,
      default: () => ({
        onSubmit: () => {},
        maxPeriodMonths: null,
        periodErrorMessage: "",
      }),
    },
  },
  data() {
    return {
      start: "",
      end: "",
      errorMessage: null,
    };
  },
  computed: {
    minDate() {
      const date = new Date();
      date.setFullYear(date.getFullYear() - 5);
      return date.toISOString().split("T")[0];
    },
    maxPeriodMonths() {
      return this.componentProps.maxPeriodMonths || null;
    },
    maxEndDate() {
      if (!this.maxPeriodMonths) return null;

      return getLastPeriodDate(this.start, this.maxPeriodMonths);
    },
    periodError() {
      if (!this.maxPeriodMonths || !this.start || !this.end) return null;

      return isPeriodInMonthsValid(this.start, this.end, this.maxPeriodMonths)
        ? null
        : this.componentProps.periodErrorMessage ||
            "Превышен максимально допустимый период";
    },
    errorText() {
      return this.errorMessage || this.periodError;
    },
    isValid() {
      return (
        this.start &&
        this.end &&
        new Date(this.end) >= new Date(this.start) &&
        !this.periodError
      );
    },
  },
  methods: {
    save() {
      if (!this.isValid) return;

      this.componentProps.onSubmit({
        start: this.start,
        end: this.end,
      });
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/less/variables.less";

label {
  display: block;
  padding-left: 20px;
  margin-bottom: 8px;
  font-weight: 500;
  color: @text-color-middle;
}

input[type="date"] {
  width: 100%;
  margin-bottom: 20px;
  padding: 8px 12px;
  border: 1px solid @border-color;
  border-radius: @br;
  font-size: 14px;

  &:focus {
    outline: none;
    border-color: @primary-color;
  }
}

.form-footer {
  padding: 16px 20px 0 0;
  text-align: right;
}
</style>
